import React from "react";
import "./topbar.css";
import Logo from "./logo.png";
import { Language, Settings } from "@material-ui/icons";
import LogoutIcon from "@mui/icons-material/Logout";
import { useHistory, useLocation, matchPath } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

const ROUTES = [
  { path: "/gamelog/:logId", title: "Game Details" },
  { path: "/gamelog", title: "Game Schedule & Results", exact: true },
  { path: "/myteam", title: "Team & Roster" },
  { path: "/selectteam", title: "Select Team" },
  { path: "/opponents", title: "Select Opponent" },
  { path: "/editteam", title: "Edit Team" },
  { path: "/accountsettings", title: "Account Settings" },
  { path: "/settings", title: "Team Settings" },
  { path: "/opproster", title: "Opponent Details" },
  { path: "/settingTurnoverDescription", title: "Additional Turnover Description" },
  { path: "/teamrules", title: "Game Rules" },
  { path: "/", title: "", exact: true },
];

export default function Topbar() {
  const dispatch = useDispatch();
  const { isAdmin } = useSelector((state) => state.auth);
  const history = useHistory();

  const logout = async () => {
    dispatch({ type: "LOGOUT" });
    // history.push("/login");
  };

  const location = useLocation();

  const matched = ROUTES.find((r) =>
    matchPath(location.pathname, { path: r.path, exact: !!r.exact })
  );

  let title = matched ? matched.title : "";
  
  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft" onClick={() => history.push("/")}>
          <img className="logo" src={Logo} alt="LAXSTATCLOCK Logo" />
        </div>
        <div className="brandContainer">
            <h1 style={{ color: "white" }}>{title}</h1>
          </div>
        <div className="topRight">
          <button onClick={logout} className="logoutBtn">
            <LogoutIcon className="logoutIcon" />
            <span className="logoutText">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
}